/* eslint-disable no-undef */
<template>
  <div>
    <div class="content">
      <div class="content-add-detail">
        <el-form :model="queryParams" class="demo-form-inline" label-position="left">
          <div class="add-basic-information">
            <div class="add-title">
              <span class="basic title-font-style">发货信息</span>
            </div>
            <div class="add-content details-line-height" style="padding:0 0 10px 50px;">
              <el-row>
                <el-col :span="8">
                  <el-col :span="18">
                    <el-form-item label="发货编号：">
                      <span>{{ queryParams.deliverNumber ||'--'}}</span>
                    </el-form-item>
                  </el-col>
                </el-col>
                <el-col :span="8">
                  <el-col :span="18">
                    <el-form-item label="配送方式：">
                      <span>
                        {{
                        queryParams.logisticType ||'--'
                        }}
                      </span>
                    </el-form-item>
                  </el-col>
                </el-col>
              </el-row>
              <el-row>
                <el-col :span="8">
                  <el-col :span="18">
                    <el-form-item label="入库仓库：">
                      {{
                      queryParams.storageName ||'--'
                      }}
                    </el-form-item>
                  </el-col>
                </el-col>
                <el-col :span="8">
                  <el-col :span="18">
                    <el-form-item label="仓库地址：" label-width="71px">
                       <el-tooltip
                      :content=" queryParams.storageAddress"
                      class="overflow-ellipsis"
                      effect="dark"
                      placement="top"
                    >
                      <span style="width: 100%">{{ queryParams.storageAddress|| '--'}}</span>
                    </el-tooltip>
                    </el-form-item>
                  </el-col>
                </el-col>
                <el-col :span="8">
                  <el-col :span="18">
                    <el-form-item label="联系电话：">
                      {{
                      queryParams.storagePhone ||'--'
                      }}
                    </el-form-item>
                  </el-col>
                </el-col>
              </el-row>
              <el-row>
                <el-col :span="8">
                  <el-col :span="18">
                    <el-form-item label="入库类型：">
                      {{
                      queryParams.instockType ||'--'
                      }}
                    </el-form-item>
                  </el-col>
                </el-col>
                <el-col :span="8">
                  <el-col :span="18">
                    <el-form-item label="发起人：">
                      {{
                      queryParams.createUser||'--'
                      }}
                    </el-form-item>
                  </el-col>
                </el-col>
                <el-col :span="8">
                  <el-col :span="18">
                    <el-form-item label="发起时间：">
                      {{
                      queryParams.createDate | dateFilterL
                      }}
                    </el-form-item>
                  </el-col>
                </el-col>
              </el-row>
            </div>
          </div>
          <div class="add-basic-information">
            <div class="add-title">
              <span class="basic title-font-style">物流信息</span>
            </div>
            <div class="add-content details-line-height" style="padding:0 0 10px 50px;">
              <el-row v-for="(item,index) in distribution" :key="index">
                <el-col :span="8">
                  <el-form-item label="物流公司：" label-width="71px">
                    <el-tooltip
                      :content="item.logisticCompany"
                      class="overflow-ellipsis"
                      effect="dark"
                      placement="top"
                    >
                      <span style="width: 100%">{{item.logisticCompany|| '--'}}</span>
                    </el-tooltip>
                  </el-form-item>
                </el-col>
                <el-col :span="8">
                  <el-col :span="18">
                    <el-form-item label="物流单号：" label-width="71px">
                      <el-tooltip
                      :content="item.logisticNumber"
                      class="overflow-ellipsis"
                      effect="dark"
                      placement="top"
                    >
                      <span style="width: 100%">{{item.logisticNumber|| '--'}}</span>
                    </el-tooltip>
                    </el-form-item>
                  </el-col>
                </el-col>
                <el-col :span="8">
                  <el-col :span="18">
                    <el-form-item label="物流费用：">{{item.expressFee ||'--'}}</el-form-item>
                  </el-col>
                </el-col>
              </el-row>
            </div>
          </div>
          <div class="add-basic-information" style="padding-bottom:20px;">
            <div class="add-title add-title1" style="padding-left:20px;">
              <div>
                <span class="basic title-font-style">入库清单</span>
              </div>
              <span style="text-align:right;padding-right:20px;">
                <el-button plain @click="toExport">导出入库清单</el-button>
              </span>
            </div>
            <!--startprint-->
            <div class="box-table" style="padding-bottom:14px;">
              <el-table
                max-height="378"
                border
                ref="tableRef"
                tooltip-effect="dark"
                :data="list"
                :header-cell-style="tableHeader"
                v-loading="loadingTable"
                element-loading-text="拼命加载中请稍后..."
                element-loading-spinner="el-icon-loading"
              >
                <el-table-column label="品牌" prop="brandName" show-overflow-tooltip></el-table-column>
                <el-table-column label="产品名称" prop="proName" show-overflow-tooltip></el-table-column>
                <el-table-column label="型号" show-overflow-tooltip>
                  <template slot-scope="scope">
                    <div
                      class="approval line-limit-length"
                      @click="detailModel(scope.row)"
                    >{{ scope.row.proModel || '--'}}</div>
                  </template>
                </el-table-column>
                <el-table-column label="订货号" prop="proOrdernum" show-overflow-tooltip></el-table-column>
                <el-table-column label="单位">
                  <template slot-scope="scope">
                    <div>{{ scope.row.proUnit || '--'}}</div>
                  </template>
                </el-table-column>
                <el-table-column label="调拨仓库" show-overflow-tooltip v-if="instockType === 2">
                  <template slot-scope="scope">
                    <div class="line-limit-length">{{ scope.row.fromStorageName ||'--'}}</div>
                  </template>
                </el-table-column>
                <el-table-column label="调拨货架" show-overflow-tooltip v-if="instockType === 2">
                  <template slot-scope="scope">
                    <div class="line-limit-length">{{ scope.row.fromShelvesName ||'--'}}</div>
                  </template>
                </el-table-column>
                <el-table-column label="数量" v-if="instockState === 1">
                  <template slot-scope="scope">
                    <div>{{ scope.row.deliverCount || '--'}}</div>
                  </template>
                </el-table-column>
                <el-table-column label="实际入库数">
                  <template slot-scope="scope">
                    <div>{{ scope.row.warehouseCount|| '--' }}</div>
                  </template>
                </el-table-column>
                <el-table-column label="产品序列号" v-if="instockState === 1">
                  <template slot-scope="scope">
                    <el-button type="text" @click="toEntry(scope.$index,scope.row)">点击录入</el-button>
                  </template>
                </el-table-column>
                <el-table-column
                  label="产品序列号"
                  v-if="instockState === 2 || instockState === 3 || instockState === 4"
                >
                  <template slot-scope="scope">
                    <el-button type="text" @click="checkSerial(scope.$index,scope.row)" plain>查看</el-button>
                  </template>
                </el-table-column>
                <el-table-column label="货架">
                  <template slot-scope="scope">
                    <div>{{ scope.row.shelvesName || '--'}}</div>
                  </template>
                </el-table-column>
                <el-table-column label="操作" fixed="right" v-if="instockState === 1">
                  <template slot-scope="scope">
                    <el-button type="text" @click="toVacancy(scope.$index,scope.row)">报缺</el-button>
                  </template>
                </el-table-column>
                <el-table-column label="入库批次" v-if="instockState !== 1" show-overflow-tooltip>
                  <template slot-scope="scope">
                    <div class="line-limit-length">{{ scope.row.batchNumber || '--'}}</div>
                  </template>
                </el-table-column>
              </el-table>
            </div>
            <!--endprint-->
            <div
              style="color:#D35E5E;margin-left:20px;font-size:12px;"
              v-if="instockState === 4"
            >当前入库单已作废</div>
          </div>
        </el-form>

        <!-- --------------------待入库 查看序列号侧边栏---------------------- -->
        <see-shipment ref="seeShipmentRefs"></see-shipment>
      </div>
    </div>
  </div>
</template>

<script>
import { queryStorageInstockContent } from '@/api/storage/storage'
import { downLoadFileBlob } from '@/util/tool'
import { addStorageInstockCoeDeriveProcessed } from '@/api/purchase/purchaseManage'
import logisticsSlider from '../slideBar/logisticsSlider'

export default {
  components: {
    'see-shipment': logisticsSlider
  },
  data() {
    return {
      list: [], // 入库清单
      distribution: [
        {
          logisticCompany: '',
          logisticNumber: '',
          expressFee: ''
        }
      ], // 物流信息、
      queryParams: {}, // 发货信息
      pitchOnPpId: [],
      loadingTable: false,
      isUpdate: false,
      mark: '', // 中通备注
      instockState: '', // 入库状态 1待验收 2待入库 3已入库 4作废
      logisticType: '', // 配送方式: 1物流入库 2配送入库,
      instockType: '', // 入库类型
      warehouseCount: '',
      marks: '',
      serialCode: '',
      shelvesNames: [],
      shelveData: [],
      activeNameInput: ''
    }
  },
  mounted() {
    this.queryStorageInstockContent()
    this.instockState = Number(this.$route.query.instockState)
    this.instockType = Number(this.$route.query.instockType)
  },
  // 离开当前页 重定向到首页列表页
  beforeRouteLeave(to, from, next) {
    if (to.path === '/storage/storageManage/logisticsGoToDetail') {
      this.$router.push({ name: 'logisticsGoToWarehouseList' })
    } else {
      next()
    }
  },
  methods: {
    // 根据bizId和入库类型instockType 获取物流入库详情
    queryStorageInstockContent() {
      queryStorageInstockContent(this.$route.query.id, this.$route.query.instockType)
        .then(res => {
          if (res.data.code === 200) {
            this.queryParams = res.data.obj.storageDeliverBaseVo // 发货信息
            this.distribution = res.data.obj.storageLogisticVoList // 物流信息
            if (res.data.obj.storageDeliverContentVoList !== null) {
              this.list = res.data.obj.storageDeliverContentVoList // 入库清单
            } else {
              this.list = []
            }
          } else {
            this.$message.error(res.data.msg)
          }
        })
        .catch(err => {
          console.log(err)
        })
    },
    // 侧边栏val
    checkSerial($index, row) {
      this.$refs.seeShipmentRefs.onInitialize(row)
    },
    // 循环添加form 表单
    toAddLogistic(list) {
      list.push({})
    },
    // 删除form表单中某一条
    toDelLogistic(list, index) {
      list.splice(index, 1)
    },
    // 打印入库单
    toExportPort() {
      // const bdhtml = window.document.body.innerHTML
      // const sprnstr = '<!--startprint-->' // 开始打印标识字符串有17个字符
      // const eprnstr = '<!--endprint-->' // 结束打印标识字符串
      // let prnhtml = bdhtml.substr(bdhtml.indexOf(sprnstr) + 17) // 从开始打印标识之后的内容
      // prnhtml = prnhtml.substring(0, prnhtml.indexOf(eprnstr)) // 截取开始标识和结束标识之间的内容
      // window.document.body.innerHTML = prnhtml // 把需要打印的指定内容赋给body.innerHTML
      // window.print() // 调用浏览器的打印功能打印指定区域
      // window.document.body.innerHTML = bdhtml // 最后还原页面
    },
    toExport() {
      const queryParams = {}
      queryParams.bizId = this.$route.query.id
      queryParams.instockType = this.$route.query.instockType
      if (this.queryParams.logisticType === '物流配送') {
        queryParams.instockUrl = this.$store.state.inventoryListGuid
      } else if (this.queryParams.logisticType === '快递配送') {
        queryParams.instockUrl = this.$store.state.expressInventoryListGuid
      } else if (this.queryParams.logisticType === '供应商配送') {
        queryParams.instockUrl = this.$store.state.supplierInventoryListGuid
      }
      addStorageInstockCoeDeriveProcessed(queryParams)
        .then(res => {
          downLoadFileBlob(this, res)
        })
        .catch(err => {
          console.log(err)
        })
    },
    // 跳产品详情页
    detailModel(row) {
      this.$router.push({
        path: '/product/productManage/productDetails',
        query: { id: row.proId }
      })
    },
    // 设置头部颜色
    tableHeader({ rowIndex }) {
      return this.$tableHeader(rowIndex)
    }
  }
}
</script>
<style lang="scss" scoped>
.span_row {
  display: flex;
  span {
    width: 94px;
  }
}
.add-basic-information .bottom {
  padding: 0 30px 30px 30px;
}
.add-basic-information .bottom-tip {
  margin: 15px 0;
}
.add-title1 {
  display: flex;
  justify-content: space-between;
  padding: 30px 0 0 30px;
}
.logistics-information {
  font-size: 16px;
  font-weight: bold;
  color: #4e555b;
  margin-bottom: 10px;
}
</style>
